// src/components/tracking/ErrorBoundary.tsx
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { unifiedEventDispatcher } from '../../tracking/gtm/services/unified-event-dispatcher';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    unifiedEventDispatcher.pushUnifiedEvent('0.02_EVENT_DISTRIBUTOR', {
      eventParams: {
        pageType: 'error',
        utm_source: error.message,
        utm_term: errorInfo.componentStack ?? ''
      }
    });
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Sorry.. there was an error</h1>
        </div>
      );
    }

    return this.props.children;
  }
}
